// The Create Bill Run dialog's default period: last month, listed 1st to 1st.
// 1 Sep -> 1 Oct bills 1 Sep 00:00 to 30 Sep 23:59:59; period_end is the
// EXCLUSIVE 1st of the following month (CLAUDE.md §7.2), the convention bill
// runs and clients use.
//
// Built from local date parts, never toISOString(): that formats in UTC, so a
// local midnight east of Greenwich comes out as the previous day. "Last month"
// is the operator's local month, which is the calendar the billing runs on.

const dateKey = (year: number, monthIndex: number): string => {
  // Date normalises month -1 / 12 across the year boundary.
  const d = new Date(year, monthIndex, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
};

export function defaultBillRunPeriod(now: Date): { start: string; end: string } {
  return {
    start: dateKey(now.getFullYear(), now.getMonth() - 1),
    end: dateKey(now.getFullYear(), now.getMonth()),
  };
}
